module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/banner_special01-7f42303e732fefe4303468b66fada8eb.png";